import React from 'react';

const Footer = () => {
    return (
        <footer className="footer sticky-bottom">
            <div className='text-center'>
                <a href="https://www.instagram.com/andrewyu22" target="_blank" rel="noreferrer"><i className="bx bxl-instagram bx-md"></i></a>
                <a href="https://github.com/andrewyu22" target="_blank" rel="noreferrer"><i className="bx bxl-github bx-md"></i></a>
                <a href="https://www.linkedin.com/in/andrew-yu-b03181125" target="_blank" rel="noreferrer" ><i className="bx bxl-linkedin bx-md"></i></a>
            </div>
        </footer>
    )
}

export default Footer;